"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flatDisabledStyle = exports.outlinedDisableStyle = exports.filledDisabledStyle = void 0;

var tslib_1 = require("tslib");

var styled_components_1 = require("styled-components");

var colors_1 = require("../../../styles/colors");

exports.filledDisabledStyle = styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n\tcolor: ", ";\n\tbackground: ", ";\n\tborder-color: ", ";\n"], ["\n\tcolor: ", ";\n\tbackground: ", ";\n\tborder-color: ", ";\n"])), colors_1.white, colors_1.gray[300], colors_1.gray[300]);
exports.outlinedDisableStyle = styled_components_1.css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n\tcolor: ", ";\n\tbackground: ", ";\n\tborder-color: ", ";\n"], ["\n\tcolor: ", ";\n\tbackground: ", ";\n\tborder-color: ", ";\n"])), colors_1.gray[500], colors_1.gray[50], colors_1.gray[300]);
exports.flatDisabledStyle = styled_components_1.css(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n\tcolor: ", ";\n\tbackground: ", ";\n\tborder-color: ", ";\n"], ["\n\tcolor: ", ";\n\tbackground: ", ";\n\tborder-color: ", ";\n"])), colors_1.gray[500], colors_1.transparent, colors_1.transparent);
var templateObject_1, templateObject_2, templateObject_3;